import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

interface ColumnType {
  title: string
  dataIndex: string
  node: string // 默认a-input
  disabled: boolean
  span: number
}

import { computed } from 'vue'
import type { PropType } from 'vue'
const __default__ = { name: 'DetailCard' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  columns: {
    type: Array as PropType<ColumnType[]>,
    default: () => []
  },
  data: {
    type: Object,
    default: () => null
  },
  disabled: {
    type: Boolean,
    default: true // 是否表单不可选择
  },
  span: {
    type: Number,
    default: 6
  },
  title: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props
// 处理Column
// 重新定义列描述数据对象
const columnsComputed = computed(() => {
  const result = props.columns.map((item: ColumnType) => {
    item.disabled = item.disabled === undefined ? props.disabled : item.disabled
    item.node = item.node || 'cos-input'
    return item
  })
  return result
})

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!

  return (_openBlock(), _createBlock(_component_dc_layout_card, {
    title: __props.title,
    span: __props.span
  }, {
    subTitle: _withCtx(() => [
      _renderSlot(_ctx.$slots, "subTitle")
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnsComputed.value, (item, i) => {
        return (_openBlock(), _createBlock(_component_dc_form_item, {
          key: i,
          span: item.span || __props.span,
          name: item.dataIndex,
          label: item.title
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "bodyCell", {
              text: __props.data[item.dataIndex],
              record: __props.data,
              index: i,
              column: item
            }, () => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.node), _mergeProps(item.attrs, {
                value: __props.data[item.dataIndex],
                disabled: item.disabled,
                view: ""
              }), null, 16, ["value", "disabled"]))
            ])
          ]),
          _: 2
        }, 1032, ["span", "name", "label"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["title", "span"]))
}
}

})